export default {
    organisation: 'Organisation',
    mailTemplate: 'E-Mailvorlage',
    notification_mode: 'Benachrichtigungsmodus',
    sendTo: 'Senden an',
}